import React, { useState } from 'react';
import styled from 'styled-components';
import { CircularProgress } from '@material-ui/core';
import { useDispatch } from 'react-redux';
import { ButtonMain } from '../../atoms';
import { setMergingFormsArray, setShowMergingForms } from '../../redux/slices/inspectionsSlice';
import { getCustomActivities } from '../../api/activities';
import { Sort } from './SortUtil';

// Pull EVERY Inspection activity for the permit, not just the page the table is
// currently showing — the merged PDF must cover all inspections. We page through
// the LimitOffset endpoint in chunks of PAGE_LIMIT until `count` records are
// collected, so the total fetched is the real count (156, 600, …), not a cap.
// 500 is large enough that a typical permit is one round-trip; the loop below
// still handles permits with more than that.
const PAGE_LIMIT = 500;

const DownloadAllPermitsButton = ({ permit }) => {
  const dispatch = useDispatch();
  const [loading, setLoading] = useState(false);

  const fetchPage = (offset: number) =>
    getCustomActivities({
      is_deleted: false,
      limit: PAGE_LIMIT,
      offset,
      permit_id: permit,
      ordering: null,
      event_type: 'Inspection',
    });

  // Lazy load: this potentially large fetch only runs when the user actually
  // asks to download, so simply viewing the Inspections tab costs nothing beyond
  // the table's own request.
  const handleClick = async () => {
    setLoading(true);
    try {
      const all: any[] = [];
      let offset = 0;
      let count = Infinity;

      while (offset < count) {
        // eslint-disable-next-line no-await-in-loop
        const res = await fetchPage(offset);
        const results: any[] = res.data?.results || [];
        count = res.data?.count ?? results.length;
        if (results.length === 0) break;
        all.push(...results);
        offset += results.length;
        if (results.length < PAGE_LIMIT && all.length >= count) break;
      }

      const reports = Sort(all.filter(item => item.report));
      dispatch(setMergingFormsArray(reports));
      dispatch(setShowMergingForms(true));
    } finally {
      setLoading(false);
    }
  };

  return (
    <WideButton>
      <ButtonWrapper>
        <ButtonMain
          disabled={loading}
          startIcon={loading ? <CircularProgress size={16} color="inherit" /> : undefined}
          onClick={handleClick}
        >
          {loading ? 'Loading inspections…' : 'Download Inspection Reports'}
        </ButtonMain>
      </ButtonWrapper>
    </WideButton>
  );
};

export default DownloadAllPermitsButton;

const WideButton = styled.div`
  display: flex;
  width: auto;
`;

const ButtonWrapper = styled.div`
  width: 300px;
`;
